/*!
 * ThumbnailsView - Vue miniatures d'images pour IconsView
 */

import CardView from './CardView';

export default class ThumbnailsView extends CardView {
    constructor(plugin, name = 'thumbnails') {
        super(plugin, name);
    }

    renderIcon(data, container, subdir, path) {
        const myself = this.plugin;
        if (data.type === 'root') return true;

        const currentType = this.getTypes(data);
        const currentClassAll = this.buildItemClasses(data, currentType, (data.class || data.cls || ''));

        const thumbFields = myself.getViewFields(this.name);
        const codeSubtext = this.buildFieldsSubtext(data, thumbFields);

        const thumbConf = myself.getViewConfig(this.name);
        const thumbDefaultSize = (this.name === 'slideshow') ? 128 : 256;
        let thumbsWidth = thumbDefaultSize;
        let thumbsHeight = thumbDefaultSize;

        if (myself.dataNodeParent && myself.dataNodeParent.thumbs) {
            thumbsWidth = myself.dataNodeParent.thumbs.width;
            thumbsHeight = myself.dataNodeParent.thumbs.height;
        } else if (thumbConf && (thumbConf.width || thumbConf.height)) {
            thumbsWidth = thumbConf.width || thumbConf.size || thumbDefaultSize;
            thumbsHeight = thumbConf.height || thumbConf.size || thumbDefaultSize;
        } else if (thumbConf && thumbConf.size) {
            thumbsWidth = thumbConf.size;
            thumbsHeight = thumbConf.size;
        } else {
            const resolvedThumbSize = myself.getViewIconSize(this.name);
            if (resolvedThumbSize && resolvedThumbSize !== 24 && resolvedThumbSize !== 128) {
                thumbsWidth = resolvedThumbSize;
                thumbsHeight = resolvedThumbSize;
            }
        }

        myself.viewThumbsWidth = thumbsWidth;
        myself.viewThumbsHeight = thumbsHeight;
        myself.viewThumbsProportions = thumbsWidth / thumbsHeight;
        myself.viewItemWidthRatio = thumbsWidth / thumbsHeight;
        myself.viewItemThumbsMode = true;
        myself.viewItemWidthMin = 48;
        myself.viewItemWidthMax = 512;

        const columns = [];
        const thumbActions = myself.getViewActions(this.name);
        if (thumbActions && thumbActions.length) {
            $.each(thumbActions, (indexView, column) => {
                if (column.type === 'action') {
                    if (data.actions) {
                        const action = data.actions[column.name];
                        if (action) {
                            const buttonIcon = myself.renderIconImage('small', action.icon);
                            const columnData = '<div class="iv__item__action button-icon">'
                                    + '<button class="action--default action" title="' + action.label + '" data-action="' + column.name + '">' + buttonIcon + '</button>'
                                    + '</div>';
                            columns.push(columnData);
                        }
                    }
                }
            });
        }

        let previewCode = '';
        if (data.html && !data.thumb) {
            previewCode = '<div class="iv__item__image"><div class="iv__item__html" style="' + ((thumbConf && (thumbConf.margin || thumbConf.margin === 0)) ? 'margin:' + thumbConf.margin + ';' : '') + '">' + data.html + '</div></div>';
        } else {
            previewCode = '<span class="iv__item__image" style="width:' + thumbsWidth + 'px; height:' + thumbsHeight + 'px; ' + ((data.color) ? 'background-color: ' + data.color + ';' : '') + '">';
            if (data.thumb) previewCode += myself.renderIconImage('thumb', data.thumb, data, 'thumb');
            else if (data.logo) previewCode += myself.renderIconImage('logo', data.logo, data, 'logo');
            else previewCode += myself.renderIconImage('hd', data.icon, data, 'img');
            previewCode += '</span> ';
        }

        let countThumbHtml = '';
        if (myself.shouldShowCount(data, this.name)) {
            countThumbHtml = ' <span class="iv__item__count">(' + data.count + ')</span>';
        }

        const code = '<div class="' + currentClassAll + '"><div class="iv__item__frame" style="max-width:' + thumbsWidth + 'px;"><span class="iv__item__link">'
                + previewCode
                + '<label class="iv__item__label">'
                + '<span class="iv__item__name titre">' + (data.label ? data.label : '&nbsp;') + '</span>'
                + countThumbHtml
                + ((codeSubtext.length > 0) ? '<span class="iv__item__data infos">' + codeSubtext.join('') + '</span>' : '')
                + '</label></span></div>' + (columns.length ? '<div class="iv__item__actions">' + columns.join('') + '</div>' : '') + '</div>';

        const currentIcon = $(code);
        const currentIconReact = currentIcon.find('.iv__item__image, .iv__item__name');

        container.append(currentIcon);
        this.attachItemEvents(currentIcon, currentIconReact, data, currentType, path);
        this.renderBadge(data, currentIcon);

        return currentIcon;
    }

    resize() {
        const myself = this.plugin;
        let thumbsWidth = myself.viewThumbsWidth;
        let thumbsHeight = myself.viewThumbsHeight;
        if (thumbsWidth) {
            const marginFix = 16;
            const canvaWidth = myself.element.find('.view').width() - 1;
            const colCount = canvaWidth / (thumbsWidth + marginFix);
            const colCountFix = Math.ceil(colCount);
            thumbsWidth = Math.floor((canvaWidth / colCountFix) - marginFix);
            thumbsHeight = (thumbsHeight / myself.viewThumbsWidth) * thumbsWidth;

            myself.element.find('.iv__item').not('.iv__tabs__btn, .iv__breadcrumb__item').find('> div').css('max-width', thumbsWidth);
            myself.element.find('.iv__item').not('.iv__tabs__btn, .iv__breadcrumb__item').find('.iv__item__image').css('width', thumbsWidth)
                .css('height', thumbsHeight);
        }
    }

    getZoomLimits() {
        return { enabled: true, min: 96, max: 512 };
    }
}
